import React from 'react';
import { IconProps } from '../../DefaultIcon';
export function ProfessionalStatusIcon({ className }: IconProps) {
  return (
    <svg
      width="69"
      height="88"
      viewBox="0 0 69 88"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_1972)">
        <path
          d="M68.9551 67.3567C67.4133 55.5448 59.8832 45.6237 49.4929 40.6631C45.2251 43.5549 40.0412 45.2455 34.4997 45.2455C28.9583 45.2455 23.7744 43.5549 19.5065 40.6631C9.11632 45.6237 1.5862 55.5448 0.0220857 67.3567C-0.290738 69.7369 1.60855 71.8501 4.02176 71.8501H64.9554C67.3686 71.8501 69.2679 69.7369 68.9551 67.3567Z"
          fill="#00416B"
        />
        <path
          d="M53.2025 18.6411C53.2025 28.9181 44.8233 37.2821 34.4778 37.2821C24.1323 37.2821 15.7754 28.9403 15.7754 18.6411C15.7754 8.34176 24.1546 0 34.5001 0C44.8457 0 53.2249 8.34176 53.2249 18.6411"
          fill="#00416B"
        />
        <path
          d="M35.7962 56.7906C35.5057 55.8341 35.7291 54.8108 36.3548 54.0322L45.3373 42.9321C42.0303 44.4003 38.3658 45.2233 34.5002 45.2233C30.6346 45.2233 26.9924 44.4003 23.6631 42.9321L32.6233 54.01C33.2489 54.7663 33.45 55.7896 33.1819 56.7461L27.6404 76.5883C27.417 77.4114 27.551 78.3012 27.9979 79.0353L33.3383 87.377C33.8522 88.2001 35.0588 88.2001 35.5951 87.3993L41.1812 79.0575C41.6728 78.3012 41.8292 77.3669 41.5611 76.5216L35.7738 56.7906H35.7962Z"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_1972">
          <rect width="69" height="88" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
